import React from 'react';
import './ChangePassword.scss';
import { editPassword } from '../../helper/helper';
import toast from 'react-hot-toast';
import ChangePasswordUI from './ChangePasswordUI';

const ChangePassword = () => {
  const username = localStorage.getItem('username');


  const handleSubmit = ({ oldPass, newPass, confirmPass }) => {
      let passwordConfirmation = editPassword({
        username: username,
        oldPassword: oldPass,
        newPassword: newPass,
      });

      toast.promise(
        passwordConfirmation,
        {
          loading: 'Checking...',
          success: 'Password changed successfully.',
          error: ({error}) => {
            if (error.response && error.response.status === 400) {
              return 'Password does not match' ;
            } else {
              return 'Please try again!';
            }
          },
        }
      );
  };

  return (
    <ChangePasswordUI
      handleSubmit={handleSubmit}
    />
  );
};

export default ChangePassword;
